import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import {
  provideClientHydration,
  withEventReplay,
  withNoIncrementalHydration,
} from '@angular/platform-browser';
import { provideTaiga } from '@taiga-ui/core';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';
import { AuthService } from './core/auth/auth.service';
import { resolveInitialLanguage } from './core/i18n/language.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(),
    provideClientHydration(withEventReplay(), withNoIncrementalHydration()),
    provideTaiga(),
    provideCharts(withDefaultRegisterables()),
    provideTranslateService(),
    provideTranslateHttpLoader(),
    provideAppInitializer(() => {
      const auth = inject(AuthService);
      return auth.init();
    }),
    // resolveInitialLanguage() reads the user's stored/browser-detected preference, but a
    // previous version of this initializer only called it and discarded the result — the
    // language never actually switched, so the app always rendered with whatever `lang` was
    // hardcoded in provideTranslateService() above, regardless of what the switcher had set
    // last session. Actually applying it via translate.use(), awaited so it completes before
    // the router/components bootstrap, is what makes the stored choice survive a refresh.
    provideAppInitializer(() => {
      const translate = inject(TranslateService);
      return firstValueFrom(translate.use(resolveInitialLanguage()));
    }),
  ],
};
